/* Contact: one inline error for the required fields; remember name + email
   across Shopify's post/redirect so the thank-you can greet them. */
(function () {
  'use strict';
  var KEY = 'kh-contact';
  var sent = document.querySelector('[data-sent]');
  if (sent) {
    try {
      var d = JSON.parse(sessionStorage.getItem(KEY) || '{}');
      if (d.name) sent.querySelector('[data-sent-name]').textContent = d.name.split(' ')[0];
      if (d.email) sent.querySelector('[data-sent-email]').textContent = d.email;
      sessionStorage.removeItem(KEY);
    } catch (e) {}
    sent.focus();
    return;
  }

  var form = document.getElementById('contact-form');
  if (!form) return;
  var err = form.querySelector('[data-form-error]');
  var fields = Array.prototype.slice.call(form.querySelectorAll('[data-required]'));

  function valid(f) { return f.value.trim() !== '' && (f.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value.trim())); }

  form.addEventListener('submit', function (e) {
    var bad = fields.filter(function (f) { return !valid(f); });
    fields.forEach(function (f) { f.setAttribute('aria-invalid', String(bad.indexOf(f) > -1)); });
    if (bad.length) {
      e.preventDefault();
      err.hidden = false;
      bad[0].focus();
      return;
    }
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        name: form.elements['contact[name]'].value.trim(),
        email: form.elements['contact[email]'].value.trim()
      }));
    } catch (e2) {}
  });

  form.addEventListener('input', function (e) {
    if (e.target.getAttribute('aria-invalid') === 'true' && valid(e.target)) e.target.setAttribute('aria-invalid', 'false');
    if (!fields.some(function (f) { return f.getAttribute('aria-invalid') === 'true'; })) err.hidden = true;
  });
})();
